import React from 'react';
import ErrorIcon from '@atlaskit/icon/core/migration/status-error--error';
import InformationIcon from '@atlaskit/icon/core/migration/status-information--info';
import SuccessIcon from '@atlaskit/icon/core/migration/status-success--check-circle';
import WarningIcon from '@atlaskit/icon/core/migration/status-warning--warning';
import { B400, N0, N30A, N500, N700, N800 } from '@atlaskit/theme/colors';
export var flagBackgroundColor = {
  error: 'color.background.danger.bold',
  info: 'color.background.neutral.bold',
  normal: 'elevation.surface.overlay',
  success: 'color.background.success.bold',
  warning: 'color.background.warning.bold'
};
export var flagIconColor = {
  error: "var(--ds-icon-inverse, #FFFFFF)",
  info: "var(--ds-icon-inverse, #FFFFFF)",
  normal: "var(--ds-icon-subtle, #626F86)",
  success: "var(--ds-icon-inverse, #FFFFFF)",
  warning: "var(--ds-icon-warning-inverse, #172B4D)"
};
export var flagIconGlyph = {
  error: /*#__PURE__*/React.createElement(ErrorIcon, {
    label: "",
    LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat(N0, ")"),
    LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
  }),
  info: /*#__PURE__*/React.createElement(InformationIcon, {
    label: "",
    LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat(N0, ")"),
    LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #44546F)"
  }),
  normal: /*#__PURE__*/React.createElement(InformationIcon, {
    label: "",
    LEGACY_primaryColor: "var(--ds-icon-subtle, ".concat(N500, ")"),
    LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
  }),
  success: /*#__PURE__*/React.createElement(SuccessIcon, {
    label: "",
    LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat(N0, ")"),
    LEGACY_secondaryColor: "var(--ds-background-success-bold, #1F845A)"
  }),
  warning: /*#__PURE__*/React.createElement(WarningIcon, {
    label: "",
    LEGACY_primaryColor: "var(--ds-icon-warning-inverse, ".concat(N700, ")"),
    LEGACY_secondaryColor: "var(--ds-background-warning-bold, #F5CD47)"
  })
};
export var flagTextColor = {
  error: 'color.text.inverse',
  info: 'color.text.inverse',
  normal: 'color.text',
  success: 'color.text.inverse',
  warning: 'color.text.warning.inverse'
};
export var flagTextColorToken = {
  error: "var(--ds-text-inverse, ".concat(N0, ")"),
  info: "var(--ds-text-inverse, ".concat(N0, ")"),
  normal: "var(--ds-text, ".concat(N800, ")"),
  success: "var(--ds-text-inverse, ".concat(N0, ")"),
  warning: "var(--ds-text-warning-inverse, ".concat(N700, ")")
};
// TODO: DSP-2519 Interaction tokens should be used for hovered and pressed states
// https://product-fabric.atlassian.net/browse/DSP-2519
export var actionBackgroundColor = {
  success: {
    default: "var(--ds-background-inverse-subtle, ".concat(N30A, ")"),
    active: "var(--ds-background-inverse-subtle-pressed, ".concat(N30A, ")"),
    pressed: "var(--ds-background-inverse-subtle-hovered, ".concat(N30A, ")")
  },
  info: {
    default: "var(--ds-background-inverse-subtle, ".concat(N30A, ")"),
    active: "var(--ds-background-inverse-subtle-pressed, ".concat(N30A, ")"),
    pressed: "var(--ds-background-inverse-subtle-hovered, ".concat(N30A, ")")
  },
  error: {
    default: "var(--ds-background-inverse-subtle, ".concat(N30A, ")"),
    active: "var(--ds-background-inverse-subtle-pressed, ".concat(N30A, ")"),
    pressed: "var(--ds-background-inverse-subtle-hovered, ".concat(N30A, ")")
  },
  warning: {
    default: "var(--ds-background-inverse-subtle, ".concat(N30A, ")"),
    active: "var(--ds-background-inverse-subtle-pressed, ".concat(N30A, ")"),
    pressed: "var(--ds-background-inverse-subtle-hovered, ".concat(N30A, ")")
  },
  normal: {
    default: 'none',
    active: 'none',
    pressed: 'none'
  }
};
export var actionTextColor = {
  success: "var(--ds-text-inverse, ".concat(N0, ")"),
  info: "var(--ds-text-inverse, ".concat(N0, ")"),
  error: "var(--ds-text-inverse, ".concat(N0, ")"),
  warning: "var(--ds-text-warning-inverse, ".concat(N700, ")"),
  normal: "var(--ds-link, ".concat(B400, ")")
};